import React, { Component } from 'react';
import { TextInput } from '../../../../canvasComponents/index';

export default class CustomAutocomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
      filteredSuggestions: [],
      value: props.value,
    };
    this.getSelectedLabel = this.getSelectedLabel.bind(this);
  }

  componentDidMount() {
    const { props: { suggestionsArray }, state: { value } } = this || null;

    const transformedSuggestions = suggestionsArray.map((insuranceCompany) => ({
      value: insuranceCompany.CO_CODE,
      label: <span>{insuranceCompany.CO_NAME}</span>,
    }));

    this.setState({ value, suggestions: transformedSuggestions });
  }

  onChangeAutocomplete = (currentValue) => {
    const { state: { suggestions }, props: { handleChange, index } } = this;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = suggestions.filter(
      (suggestion) => suggestion.label.props.children.toLowerCase().indexOf(currentValue.toLowerCase()) === 0,
    );

    this.setState(
      {
        filteredSuggestions,
        value: currentValue,
      },
      () => {
        let checkIfExists = false;
        suggestions.forEach((suggestion) => {
          if (suggestion.label.props.children.toLowerCase() === currentValue.toLowerCase()) {
            checkIfExists = true;
          }
        });
        // eslint-disable-next-line react/destructuring-assignment
        handleChange(checkIfExists ? this.state.value : '', index, 'insurer');
      },
    );
  };

  onClick = (selectedValue) => {
    const { handleChange, index } = this.props || null;

    this.setState(
      {
        value: selectedValue,
      },
      () => {
        // eslint-disable-next-line react/destructuring-assignment
        handleChange(this.state.value, index, 'insurer');
      },
    );
  };

  getSelectedLabel = (selectedValue) => {
    const { state: { suggestions } } = this;
    if (suggestions.length) {
      const foundSelectedLabel = suggestions.find((suggestion) => suggestion.value === selectedValue);
      if (foundSelectedLabel) {
        return foundSelectedLabel.label.props.children;
      }
    }
    return selectedValue;
  };

  render() {
    const { onChangeAutocomplete, onClick, state: { value, filteredSuggestions }, props: { disabled, name, placeholder } } = this;

    return (
      <TextInput
        autocomplete
        searchable
        searchResults={filteredSuggestions}
        emptySearchResultsMessage="No results"
        minLengthForSearchResults={1}
        disabled={disabled}
        name={name}
        placeholder={placeholder}
        highlight
        primary
        onSelect={(selectedValue) => onClick(selectedValue)}
        onChange={(currentValue) => onChangeAutocomplete(currentValue)}
        defaultValue={value ? this.getSelectedLabel(value) : ''}
      />
    );
  }
}
